"use client";
import { useEffect } from 'react';
import { ReactLenis, useLenis } from "lenis/react";
import { usePathname } from 'next/navigation';

function ScrollManager({ children }: { children: React.ReactNode }) {
  const lenis = useLenis();
  const pathname = usePathname();

  useEffect(() => {
    // Reset scroll position to top on route change
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      // Fallback for when lenis isn't ready yet
      window.scrollTo(0, 0);
    }
    
    // Additional reset after a short delay to handle any timing issues
    const timeoutId = setTimeout(() => {
      if (lenis) {
        lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo(0, 0);
      }
    }, 50);
    
    return () => clearTimeout(timeoutId);
  }, [pathname, lenis]);

  return <>{children}</>;
}

export default function SmoothScrolling({ children }: { children: React.ReactNode }) {
  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.5, syncTouch: true }}>
      <ScrollManager>
        {children}
      </ScrollManager>
    </ReactLenis>
  );
}

